export const TRUCK_LOAD_CAPACITY = 53;
